import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {AthleteNextGameModuleController} from "../athlete-next-game.module.controller";

export class AthleteNextGameModuleProps extends BaseModuleProps {
  controller: AthleteNextGameModuleController;
}
